<div class="table-responsive">
    <table mdbTable class="table table-hover">
      <thead>
        <tr>
          <th>Code</th>
          <th>Name</th>
          <th>U_GB_ID_SAP</th>
          <th>Fecha Creación</th>
          <th>Fecha Sincronización</th>
          <th>Hora Creación</th>
          <th>Hora Sincronización</th>
          <th>Usuario</th>
          <th>Email</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of records" [ngClass]="{'bg-success': record.U_GB_Sincronizado === 'Y', 'bg-warning': record.U_GB_Sincronizado === 'N'}">
          <td>{{ record.Code }}</td>
          <td>{{ record.Name }}</td>
          <td>{{ record.U_GB_ID_SAP}}</td>
          <td>{{ record.U_GB_FechaCreacion }}</td>
          <td>{{ record.U_GB_FechaSincronizacion }}</td>
          <td>{{ record.U_GB_HoraCreacion }}</td>
          <td>{{ record.U_GB_HoraSincronizacion }}</td>
          <td>{{ record.U_NAME }}</td>
          <td>{{ record.E_mail }}</td>
          <td>{{ record.U_GB_Sincronizado === 'Y' ? 'Sincronizado' : 'No Sincronizado' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="isLoading" class="overlay">
    <p>Actualizando y cargando...</p>
  </div>
  